import { teacherSubjects, type Subject } from "@edu/shared";
import { useSession } from "./session.tsx";

/**
 * Предметы, которые ведёт вошедший человек, уже разрешённые: `null` и
 * отсутствие поля (старый API) дают все предметы.
 *
 * ⚠️ Читать `me.subjects` напрямую нельзя: `null` там означает ВСЕ предметы, и
 * экран, проверивший `includes` по сырому полю, спрятал бы всё у каждого, кого
 * не настраивали. Правило одно, `teacherSubjects` из `@edu/shared`.
 *
 * Без сессии (экран загрузки, анонимный вход по ссылке) это тоже все предметы:
 * спрятать инструмент от того, кому он нужен, хуже, чем показать лишний.
 */
export function useTeacherSubjects(): Subject[] {
  return teacherSubjects(useRawTeacherSubjects());
}

/**
 * Сырое значение списка: `null` и отсутствие означают «не настраивал». Нужно
 * ровно одному правилу, комнате урока, где «не настраивал» прячет меньше, чем
 * «ведёт всё» (`addExerciseBlocks` и `mathTools`). Всем остальным
 * `useTeacherSubjects`.
 */
export function useRawTeacherSubjects(): readonly string[] | null {
  const { state } = useSession();
  return state.status === "signed" ? (state.me.subjects ?? null) : null;
}
